import { PhoneInputFormik } from '@strata/react-inputs';
import { SuggestSingleSelectFormik } from '@strata/react-selects';
import { validationStrings } from '@strata/strata-ui-strings';
import * as Yup from 'yup';

import { UpdatePhoneReasons } from 'services/constants';

export const UpdateMemberDataPhone = () => (
    <>
        <PhoneInputFormik id="memberPhone" label="Member Phone" required />
        <PhoneInputFormik
            id="secondaryPhone"
            label="Payer Submitted Supplementary Phone Number"
            disabled
        />
        <SuggestSingleSelectFormik
            id="reason"
            label="Reason"
            placeholderText="Select update reason"
            required
            values={UpdatePhoneReasons}
        />
    </>
);

UpdateMemberDataPhone.initialValues = ({ memberDetails = undefined }) => ({
    secondaryPhone: memberDetails?.secondaryPhone,
});

UpdateMemberDataPhone.validationSchema = {
    memberPhone: PhoneInputFormik.validator().required(
        validationStrings.requiredField.errorMessage,
    ),
    reason: Yup.string()
        .oneOf(UpdatePhoneReasons)
        .required(validationStrings.requiredField.errorMessage),
};

UpdateMemberDataPhone.onSubmit = async ({
    treatmentDetails,
    memberDetails,
    values,
    patchMemberPhone,
}) => {
    const { payerId, treatmentId } = treatmentDetails;
    const { memberId, firstName, dateOfBirth } = memberDetails;
    const { memberPhone, reason } = values;
    await patchMemberPhone({
        payerId,
        memberId,
        firstName,
        dateOfBirth,
        treatmentId,
        memberPhone,
        reason,
    }).unwrap();
};
